module.exports = __webpack_public_path__ + "static/media/ic_inbound_co_browse_deactivate.2bb0e2d1.svg";